import { useState } from 'react';
import { Document } from '../components/document-list-vault/types';
import { toast } from 'react-toastify';
import { deleteDocumentContract, deleteDocument } from '../../../slices/documents/documentsSlice';

import { useAppDispatch } from '../../../common/hooks/useAppDispatch';
import { useAppSelector } from '../../../common/hooks/useAppSelector';
import { selectUser } from '../../../slices/user/userSlice';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { ROUTES } from '../../../common/constants/routes';
import { useErrorMessage } from '../../../common/hooks/useErrorMessage';

export const useDeleteMessageModal = () => {
  const dispatch = useAppDispatch();
  const currentUser = useAppSelector(selectUser);
  const { t } = useTranslation();
  const { getErrorMessage } = useErrorMessage();
  const navigate = useNavigate();
  const { documentId } = useParams();
  const location = useLocation();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [documentToDelete, setDocumentToDelete] = useState<Document | null>(null);
  const [pendingStatus, setPendingStatus] = useState<boolean>(false);

  const handleDeleteDocument = () => {
    if (!documentToDelete || documentToDelete.id === undefined || currentUser?.id === undefined) {
      return;
    }
    setPendingStatus(true);
    setModalOpen(false);
    dispatch(
      'contract_generation' in documentToDelete
        ? deleteDocumentContract({ id: documentToDelete.id, userId: currentUser.id })
        : deleteDocument({ id: documentToDelete.id, userId: currentUser.id })
    )
      .unwrap()
      .catch((error) => {
        if (
          error.message === 'Request failed with status code 401' ||
          error.message === 'Request failed with status code 403'
        ) {
          toast.error(t('messages.noPermissionsMessage'));
        } else {
          toast.error(getErrorMessage(error));
        }
      })
      .finally(() => {
        setDocumentToDelete(null);
        setModalOpen(false);
        setPendingStatus(false);
        if (documentId) {
          if (location.pathname.includes(ROUTES.WORKSPACE)) {
            navigate(ROUTES.WORKSPACE);
          } else if (location.pathname.includes(ROUTES.DOCUMENT_VAULT)) {
            navigate(ROUTES.DOCUMENT_VAULT);
          }
        }
      });
  };

  return {
    modalOpen,
    setModalOpen,
    documentToDelete,
    setDocumentToDelete,
    pendingStatus,
    handleDeleteDocument,
  };
};
